import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment';
import 'moment-timezone';
import 'moment-duration-format';
import classes from './Zendesk.module.css'
import { getCookie } from '../../utils/common'
import { zendeskTicketDetailsAPI } from '../../services/api/zendesk-ticket-details'
import Spinner from '../UI/Spinner'
import SessionsList from './SessionsList'
import styles from './TicketList.module.css'
import { AuthContext } from '../../store/auth-context';
import { URL } from '../../constants';
import { Link } from 'react-router-dom';


const Search = () => {

	const authCtx = useContext(AuthContext)

	const [ticketID, setTicketID] = useState('')
	const [ticketDetails, setTicketDetails] = useState<{[key:string]: any}>({})
	const [isTicketDetailsLoading, setIsTicketDetailsLoading] = useState(false)
	const [showConversations, setShowConversations] = useState(false)
	const [processedCount, setProcessedCount] = useState(0)
	const [error, setError] = useState('')

	const getConversations = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()
		if(!ticketID) {
			return true
		}		
		setError('')
		setIsTicketDetailsLoading(true)
		setTicketDetails({})
		setProcessedCount(0)
        const tenantSlug = getCookie('current_tenant')
        zendeskTicketDetailsAPI(tenantSlug).getSingle?.(ticketID)
            .then((response) => {
                setTicketID('')
				setIsTicketDetailsLoading(false)
				setTicketDetails(response)
            })
            .catch((err: any) => {
				setIsTicketDetailsLoading(false)
                if (err.response) {
                    console.log(err)
					setError(err?.response?.statusText || 'Not Found!')
                } else if (err?.request?.statusText) {
                    console.log(err.request)
					setError(err?.request?.statusText || 'Not Found!')
                } else {
                    console.log(err)
					setError("Not Found!")
                }
            })
    }

	useEffect(() => {
		if(ticketDetails?.conversations && ticketDetails?.conversations?.length) {
			let processedCount = 0
			ticketDetails?.conversations.map((conversation: any, cIdx: number) => {
				if(conversation.is_processed) {
					processedCount++
				}
			})
			setProcessedCount(processedCount)
		}
	}, [ticketDetails])

	const showConversationsList = () => {
		setShowConversations(!showConversations)
	}

	return (
		<div>
			<form className={`row g-3 ${classes.searchContainer}`} onSubmit={getConversations}>
				<div className="col-md-6">
					<label htmlFor="zendesk-number" className="form-label">
						<h5>Search a Ticket to review conversations</h5>
					</label>
					<div className='d-flex'>
						<input className="form-control me-2" id="zendesk-number" value={ticketID} onChange={(e) => setTicketID(e?.target?.value)} />
						<button type="submit" className={`btn btn-primary ${styles.customPrimaryBtn}`}>Search</button>
					</div>
				</div>
			</form>
			<div className={styles.ticketListContainer}>
			{
				isTicketDetailsLoading ?
					<div className="d-flex justify-content-center my-5 p-2">
						<Spinner size="md" />
					</div> :
					<>
						{
							ticketDetails?.conversations && ticketDetails?.conversations?.length > 0 ?
								<div className={styles.ticketContainer}>
									<div className={styles.ticketTable}>
										<div className={styles.ticketTableHeader}>
											<h6>Ticket Title</h6>
											<h6>Ticket ID</h6>
											<h6 className='text-center'>Conversations</h6>
											<h6>Recent Conversation</h6>
											<h6></h6>
										</div>
										<ul className={styles.ticketListItems}>
											<li className={`${showConversations ? styles.ticketActive : ''}`}>
												<div className={`${styles.ticketDetails} py-4`}>
													<div className={styles.ticketTitle} onClick={showConversationsList}>
														{ticketDetails.ticket_title}
														<span className={styles.toggleSession}></span>
													</div>
													<div>{ticketDetails.ticket_id}</div>
													<div className='text-center'>{ticketDetails.conversations_count}</div>
													<div>{moment.tz(ticketDetails.conversations[0].date_time, "UTC").format('MMMM DD, YYYY')}</div>
													<div className={processedCount == ticketDetails.conversations_count ? styles.processed : styles.processing}>
														{
															processedCount == ticketDetails.conversations_count ?
																<Link to={`/${authCtx.currentTenant}/${URL.conversation}/${ticketDetails.ticket_id}${ticketDetails.conversations[0].session_id ? `?session_id=${ticketDetails.conversations[0].session_id}` : ''}`}>View Conversation</Link>
																:
																`Processing ${ticketDetails.conversations_count - processedCount} of ${ticketDetails.conversations_count}...`
														}
													</div>
												</div>
												{
													ticketDetails?.conversations && ticketDetails?.conversations.length > 0 && showConversations ?
														<div className={styles.ticketContainer}>
															<SessionsList
																threadID={ticketDetails.ticket_id}
																ticketIx={'asd'}
																conversations={ticketDetails.conversations}
															/>
														</div> :
														null
												}
												
											</li>
										</ul>
									</div>
								</div> :
								(
									!isTicketDetailsLoading && ticketDetails?.ticket_id ?
										<h3 className="d-flex justify-content-center p-5">Ticket Not Found!</h3> :
										null
								)
						}
					</>							
			}
			{
				error ?
					<h4 className="d-flex justify-content-center p-4">{ error }</h4>
					:
					null
			}
			</div>
		</div>
	)
}

export default Search